declare function require(module: string): any;

export const partner = 'certwise';

export const microSites: string[] = [];
export function sideEffects() {
	require('@holmescorp/cut-scores');
	require('@holmescorp/pub-sub');
}

export const tiers = {};

export const flags = (_: Record<string, boolean>) => [
	['posttest', true],
	['practice-exam', true],
	['quiz-progress-chart', true],
	['use-alternate-next', true],
	['use-alternate-pass-view', true],
	['use-assessment-chooser', true],
	['use-audio-topics', false],
	['use-carousel-view', true],
	['use-cutscores', false],
	['use-landing-page', true],
	['use-search-in-heading', true],
	['use-study-plan', true],
	['use-topicgroup-quiz', false],
	['use-topicgroup-reading', true],
	['use-xapi', true]
];
